import { createSelector } from 'reselect';
import { credentialSelector } from '../reducers/credential';
import { sessionSelector } from '../reducers/session';
import { CredentialSchema } from '../types';

const getSchemaMap = createSelector(
  [credentialSelector.getSchemas],
  (schemas) => {
    const map: Record<string, CredentialSchema> = {};
    schemas.forEach((schema) => {
      map[schema.name] = schema;
    });
    return map;
  },
);

const getSchemaByType = (type: string) =>
  createSelector([getSchemaMap], (map): CredentialSchema | undefined => {
    return map[type];
  });

const getVisibleSchemas = createSelector(
  [
    credentialSelector.getSchemas,
    sessionSelector.getFeatureFlagList('hidden_cloud_services'),
  ],
  (allSchemas, hidden) => {
    return allSchemas.filter((schema) => !hidden.includes(schema.name));
  },
);

const getLogSchemas = createSelector(
  [credentialSelector.getSchemas],
  (schemas) => schemas.filter((schema) => schema.purpose === 'log'),
);

const getVisibleLogSchemas = createSelector([getVisibleSchemas], (schemas) =>
  schemas.filter(
    (schema) =>
      schema.purpose === 'log' &&
      !schema.display_name.toLowerCase().includes('(legacy)'),
  ),
);

const getVisibleScanSchemas = createSelector([getVisibleSchemas], (schemas) =>
  schemas.filter((schema) => schema.purpose === 'scan'),
);

const getVisibleAuthSchemas = createSelector([getVisibleSchemas], (schemas) =>
  schemas.filter((schema) => schema.purpose === 'auth'),
);

const getVisibleITSMSchemas = createSelector([getVisibleSchemas], (schemas) =>
  schemas.filter((schema) => schema.purpose === 'itsm'),
);

export const memoizedCredentialSchemaSelector = {
  getSchemaMap,
  getSchemaByType,

  getLogSchemas,

  getVisibleSchemas,
  getVisibleLogSchemas,
  getVisibleScanSchemas,
  getVisibleAuthSchemas,
  getVisibleITSMSchemas,
};
